module.exports = __webpack_public_path__ + "img/myposition_cb_김민재.a7fcffa2.png";